<template>
  <section class="jobs-section">
    <div class="container">
      <h2 class="title">Top trending developer opportunities</h2>

      <div class="jobs-container">
        <JobCard
          v-for="(job, index) in jobs"
          :key="index"
          :job="job"
        />
      </div>

      <button
        v-if="hasMore && !loading"
        class="load-more"
        @click="getJobs"
      >
        <span>Explore more jobs</span>
        <ChevronDownIcon />
      </button>
    </div>
  </section>
</template>

<script>
import ChevronDownIcon from '~/components/Common/Svg/ChevronDownIcon.vue';
import JobCard from './JobCard/JobCard.vue';
import { useJobsStore } from '~/stores/jobs';
export default {
  components: { JobCard, ChevronDownIcon },
  data() {
    return {
      loading: false,
      jobsStore: useJobsStore(),
    };
  },
  computed: {
    jobs() {
      return this.jobsStore.jobs;
    },
    hasMore() {
      return this.jobsStore.hasMoreJobs;
    },
  },
  methods: {
    async getJobs() {
      this.loading = true;
      this.jobsStore.incrementCurrentPage();

      try {
        const jobs = await this.$cmsApi.get('/public-jobs', {
          ...this.jobsStore.paginationParams,
        });
        this.jobsStore.setJobs(jobs);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './JobsSection.scss';
</style>
